import React from 'react';
import PropTypes from 'prop-types';
import { locationShape } from 'constants/propTypes';
import { FormattedMessage } from 'react-intl';
import { Row, Column, Page } from 'components/shared/Layout';
import buildNextUrl from 'utils/buildNextUrl';
import { getCta } from '../ErrorActions';
import { StyledP } from '../ErrorSection.styles';

const GenericErrorSection = ({ error, parent, location }) => (
  <Page data-testid="generic-error-section">
    <Row>
      <Column span={8} start={5} justifyContent="center">
        <h1>
          <FormattedMessage id="errorBoundary.somethingWrong" />
        </h1>
      </Column>

      <Column span={10} start={4}>
        <StyledP>
          <FormattedMessage id="genericError.errorCode" /> {error.code}
        </StyledP>
      </Column>

      <Column span={10} start={4}>
        <StyledP>
          <FormattedMessage id="genericError.errorMessage" /> {error.message}
        </StyledP>
      </Column>

      <Column span={2} start={8}>
        {getCta(error, parent, buildNextUrl(location))}
      </Column>
    </Row>
  </Page>
);

GenericErrorSection.propTypes = {
  location: locationShape,
  parent: PropTypes.instanceOf(React.Component),
  error: PropTypes.shape({
    code: PropTypes.string,
    message: PropTypes.string.isRequired
  }).isRequired
};

export default GenericErrorSection;
